import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  /**
   * Column wrapper: identity row (plate tile + specs) on top, telematics
   * status strip underneath.
   *
   * The badge used to live INSIDE `.code`, which is a fixed 182x182 centered
   * flex box built to hold exactly one thing: the registration plate. A second
   * child - a full sentence with `whiteSpace: normal` - had nowhere to go, so
   * it rendered on top of the plate and overflowed the tile. Status about the
   * vehicle is not part of its identity chip; it belongs below the card body
   * where it has the full width to sit on a single line.
   */
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  subContainerInfo: {
    display: "flex",
    gap: "15px",
    flexDirection: "row",
  },
  code: {
    width: "182px",
    height: "182px",
    flexShrink: 0,
    backgroundColor: "var(--c-surface-2)",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    padding: "8px",
    boxSizing: "border-box",
    textAlign: "center",
  },
  description: {
    flex: 1,
    minWidth: 0,
    marginLeft: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  paperTitle: {
    paddingBottom: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  mark: {
    fontSize: "13px",
    lineHeight: "1.6",
    display: "flex",
    gap: "40px",
    "@media (max-width: 968px)": {
      flexDirection: "column",
      gap: "20px",
    },
    "& > div": {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      "& > div": {
        marginBottom: 0,
      },
    },
  },
});

export default useStyles;
